module.exports = __webpack_public_path__ + "img/img3.02ae4a3d.jpeg";